<script context="module">
  export const EXPAND_TRESHOLD = 992;
</script>

<script>
  import { createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition';

  export let expand_treshold = EXPAND_TRESHOLD;
  export let keep_in_dom = true;

  const distpatch = createEventDispatcher();

  let id = 'collapse_' + Math.floor(Math.random() * 0xffff).toString(16);
  let innerWidth;
  let expanded = expand_treshold == 0;
  let treshold_exceeded = expanded;

  function toggle() {
    expanded = !expanded;
    distpatch('toggle', { expanded });
  }

  $: if (!expanded) {
    expanded = treshold_exceeded = innerWidth >= expand_treshold;
  }
</script>

<svelte:window bind:innerWidth />

<div class="collabsible">
  <div
    class="description"
    class:with-icon={$$slots.icon}
    class:expanded
    on:click={toggle}
    role={treshold_exceeded ? 'heading' : 'button'}
    aria-expanded={expanded}
    aria-controls={id}
  >
    <slot name="icon" />
    <slot name="title" />
    {#if !treshold_exceeded}
      <slot name="arrow" {expanded}>
        <span class="dropdown-arrow" />
      </slot>
    {/if}
  </div>

  {#if expanded}
    <div class="expanded" {id} transition:slide>
      <slot />
    </div>
  {:else if keep_in_dom}
    <div class="collapsed" {id}><slot /></div>
  {/if}
</div>

<style>
  .description {
    position: relative;
    display: flex;
    align-items: center;
  }

  .description > :global(*:nth-child(1)) {
    flex-grow: 2;
  }
  .description.with-icon > :global(*:nth-child(1)) {
    flex-grow: 0;
  }

  .description.with-icon > :global(*:nth-child(2)) {
    flex-grow: 2;
    margin-left: 16px;
    text-align: left;
  }

  .dropdown-arrow {
    display: block;
    width: 19px;
    height: 11px;
    margin-right: 8px;
    background-image: url('/theme/mylly2023/assets/dropdown-arrow.png');
    transition: transform 0.2s;
  }

  .expanded .dropdown-arrow {
    transform: rotate(180deg);
  }

  .collapsed {
    display: none;
  }
</style>